import { Controller, useFormContext } from "react-hook-form";

import { Select } from "ui/select";
import CustomButtonColor from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/custom-button-color/custom-button-color";
import { useButtonContent } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/use-button-content";
import { useButtonOptions } from "containers/admin/clients/client/theme-page/preview/hooks/use-button-option";
import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import { CustomSelectOption } from "containers/admin/clients/client/theme-page/preview/preview.types";
import {
  BG_COLOR,
  CUSTOM_VALUE,
  BORDER_STYLE,
  COLOR_VALUE,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button.constants";

const BorderStyleColor = () => {
  const { isEditMode } = useThemePreviewContext();
  const { control, watch } = useFormContext();
  const { handleChange, getSelectValue } = useButtonContent();
  const BUTTON_OPTIONS = useButtonOptions();

  return (
    <div className="flex flex-col gap-2">
      <Controller
        name={`button.${BORDER_STYLE}.color`}
        control={control}
        render={({ field }) => (
          <div className="flex">
            <Select
              ariaLabel="Border color"
              label="Border color"
              selectName={`button-select-${BORDER_STYLE}-color`}
              disableClearable
              options={BUTTON_OPTIONS[BG_COLOR]}
              required={false}
              disabled={!isEditMode}
              {...field}
              value={getSelectValue(BORDER_STYLE, field.value, true)}
              onChange={(el) => {
                if (el) {
                  handleChange(BORDER_STYLE, el, COLOR_VALUE, field.onChange);
                }
              }}
            />
          </div>
        )}
      />
      {watch(`button.${BORDER_STYLE}`)?.color?.value === CUSTOM_VALUE && (
        <CustomButtonColor section={BORDER_STYLE} label="Button border custom color" />
      )}
    </div>
  );
};

export default BorderStyleColor;
